import { z } from 'zod'

export const ZFindID = z.object({
  name: z.string().trim().min(1, {
    message: '이름을 입력해 주세요.',
  }),
  phoneNumber: z.string().trim().min(1, {
    message: '휴대폰 번호를 입력해 주세요.',
  }),
})

export const ZFindIDResponse = z.object({
  username: z.string(),
})

export type TFindID = z.infer<typeof ZFindID>
export type TFindIDResponse = z.infer<typeof ZFindIDResponse>
